import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Building2, Check } from "lucide-react";

export function useDepartments() {
  const [depts, setDepts] = useState([]);
  useEffect(() => {
    api.get("/departments").then(({ data }) => setDepts(data)).catch(() => {});
  }, []);
  return depts;
}

export function DeptPicker({ value, onChange, testid = "dept-picker", emptyHint = "No departments yet — the Owner can add them in Team." }) {
  const depts = useDepartments();
  const toggle = (n) => onChange(value.includes(n) ? value.filter((x) => x !== n) : [...value, n]);
  if (depts.length === 0) return <p className="text-[11px] text-muted-foreground" data-testid={`${testid}-empty`}>{emptyHint}</p>;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {depts.map((d) => {
        const on = value.includes(d.name);
        return (
          <button key={d.id} type="button" onClick={() => toggle(d.name)} data-testid={`${testid}-${d.name}`}
            className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${on ? "bg-primary text-primary-foreground border-primary" : "bg-secondary/60 border-transparent hover:border-primary/40"}`}>
            {on ? <Check className="h-3 w-3" /> : <Building2 className="h-3 w-3 opacity-60" />}{d.name}
          </button>
        );
      })}
    </div>
  );
}

export function DeptChips({ list, testid }) {
  if (!list || list.length === 0) return null;
  return (
    <span className="inline-flex flex-wrap gap-1" data-testid={testid}>
      {list.map((d) => (
        <span key={d} className="inline-flex items-center gap-0.5 rounded-full bg-sky-500/10 text-sky-700 dark:text-sky-300 px-1.5 py-0.5 text-[10px] font-medium normal-case">
          <Building2 className="h-2.5 w-2.5" />{d}
        </span>
      ))}
    </span>
  );
}
